/******************************************************************
Site Name: Standards Manual V2
Author: Sebastian Lenton

shopifySpecific.js

For JS which depends on cart.js

Note the cart is initialised at the bottom of theme.liquid

This desperately needs refactoring!

******************************************************************/

bindQuantClick();

/******************
UTILITIES
******************/

function shopify_getItemID( $element ) {
	return $element.attr( 'data-productid' );
}

//replace a div by AJAX
function AJAXReplaceDiv( url, div, callback ) {
  $( div ).load( url + ' ' + div + ' > *', function() {
    callback()
  } );
}

/******************
SHAME
******************/

//very quick/hacky way of updating the red cart total number
function cartUpdateItemNo() {
  $( '.cartQuantityCont' ).load( '/' + ' ' + '.cartQuantityCont' + ' > *' );
}

/******************
ADD TO CART BUTTONS
******************/

$('.js-shopify-btnAdd').click(function( e ) {
  var itemNo = shopify_getItemID( $( this ) );

  //get the original button text (so can change it back once we're done)
  var textOrig = $( this ).text();

  //change the text
  btnChangeText( $( this ), 'adding...' );

  //this is so it can be changed back
  $( this ).addClass( 'js-textChanging' );

  // Call the addItem() method.
  // Note the empty object as the third argument, representing no line item properties.
  CartJS.addItem( itemNo, 1, {}, {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {
        cartUpdateItemNo();

        AJAXReplaceDiv( '/', '.js-cartMain', function() {
          //if mobile, scroll to the cart
          var vpCurrent = viewportSize.getWidth();

          if( vpCurrent < desktopCurrent ) {
            scrollToTop();
          }

          //btnChangeText( $( this ), 'add to cart' );
          $menuArrow = $( '.js-btnCart' ).children( '.menuArrow');
          menuArrow_open( $menuArrow );
          cartMain_open();
          rebindCartClose();
          bindQuantClick();

          //change add text back
          //I don't know how you go about passing in a reference to the original button
          btnChangeText( $( '.js-textChanging' ), textOrig );
          $( '.js-textChanging' ).removeClass( 'js-textChanging' );
        } );
      },

      // Define an error callback to display an error message.
      "error": function( jqXHR, textStatus, errorThrown ) {

        //there is only one product, and it's already in the cart (or maybe they got unlucky and it sold out)
        if( errorThrown == 'Unprocessable Entity' ) {
          //open the cart and reset the button anyway - basically everything above, again

          //if mobile, scroll to the cart
          var vpCurrent = viewportSize.getWidth();

          if( vpCurrent < desktopCurrent ) {
            scrollToTop();
          }

          btnChangeText( $( this ), 'add to cart' );
          $menuArrow = $( '.js-btnCart' ).children( '.menuArrow');
          menuArrow_open( $menuArrow );
          cartMain_open();

          //change add text back
          //I don't know how you go about passing in a reference to the original button
          btnChangeText( $( '.js-textChanging' ), textOrig );
          $( '.js-textChanging' ).removeClass( 'js-textChanging' );

        }
      }

  });
});


/********* BUTTON CHANGE TEXT ********/

//note this will only work for an a type button
function btnChangeText( $btn, newText ) {
  //console.log( 'btnChangeText()' );
  $btn.text( newText );
}

/******************
CART: REMOVE ITEM
******************/


$( document.body ).on( 'click', '.js-shopify-itemRemove', function() {
  var itemNo = shopify_getItemID( $( this ) );

  $( '.js-cartMain__priceQuant[data-productid="' + itemNo + '"]' ).remove();
  $( '.js-cartItem[data-productid="' + itemNo + '"]' ).remove();

  btnCheckoutWaitText();

  CartJS.removeItemById( itemNo, {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      AJAXReplaceDiv( '/', '.js-cartMain', function() {
        rebindCartClose();
        bindQuantClick();
        cartUpdateItemNo();
      } );
    },

    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      //console.log( 'something went wrong' );
    }

  } );
} );


/*********************
QUANTITY SELECTORS
*********************/

  //note a few things are done using cart.js Data & Core API. Some fund is set in markup
  var inputQuantity = $( 'input.cartCash__quantity' );        //quantity input (cart, ind prod page)
  //var $goToCart = $( '.js-goToCart' );          //mini cart buttons


  //stop people from being able to type any old guff into the input fields
  $( '.cartMain' ).on( 'change', inputQuantity, function( e ) {

    //console.log( "$( '.cartMain' ).on( 'change'" );

    var thisProdID = $(e.target).attr( 'data-productid' );

    var newQuant = parseInt( $(e.target).val() );

    if( checkQuant( 0, 99, newQuant ) ) {
      $( 'input[data-productid=' + thisProdID + ']' ).val( newQuant );
    } else {
      newQuant = 1;
      $( 'input[data-productid=' + thisProdID + ']' ).val( newQuant );
    }

    CartJS.updateItemById( thisProdID, newQuant, {}, {
      // Define a success callback to display a success message.
      "success": function(data, textStatus, jqXHR) {

        AJAXReplaceDiv( '/', '.js-cartMain', function() {
          rebindCartClose();
          bindQuantClick();
          cartUpdateItemNo();
        } );
      },

      // Define an error callback to display an error message.
      "error": function(jqXHR, textStatus, errorThrown) {
        //console.log( 'something went wrong' );
      }
    } );

  });


/******************
QUANTITY BUTTONS
******************/

//check whether a quantity is valid
function checkQuant( minimum, maximum, inputVal ) {
  if( inputVal > minimum && inputVal < maximum && parseInt( inputVal ) !== 'NaN' ) {
    return true;
  }
  return false;
}

function bindQuantClick() {
  //plus and minus button click events
  $( '.js-quantDec' ).click( function( e ) {

    //console.log( "$( '.js-quantDec' ) click" );

    var productID = $( this ).attr( 'data-productid' );
    var newQuant = $( 'input[data-productid=' + productID + ']' ).val();

    newQuant = parseInt( newQuant ) - 1;

    if( checkQuant( 0, 99, newQuant ) ) {

      $( 'input[data-productid=' + productID + ']' ).val( newQuant );
      btnCheckoutWaitText();

      CartJS.updateItemById( productID, newQuant, {}, {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {

          AJAXReplaceDiv( '/', '.js-cartMain', function() {
            rebindCartClose();
            bindQuantClick();
            cartUpdateItemNo();
          } );
        },

        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          //console.log( 'something went wrong' );
        }
      } );
    }
  } );

  $( '.js-quantInc' ).click( function( e ) {

    //console.log( "$( '.js-quantInc' ) click" );

    var productID = $( this ).attr( 'data-productid' );
    var newQuant = $( 'input[data-productid=' + productID + ']' ).val();
    newQuant = parseInt( newQuant ) + 1;

    if( checkQuant( -1, 99, newQuant ) ) {

      $( 'input[data-productid=' + productID + ']' ).val( newQuant );
      btnCheckoutWaitText();

      CartJS.updateItemById( productID, newQuant, {}, {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {

          AJAXReplaceDiv( '/', '.js-cartMain', function() {
            rebindCartClose();
            bindQuantClick();
            cartUpdateItemNo();
          } );
        },

        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
          //console.log( 'something went wrong' );
        }
      } );
    }
  } );
}



/******************
MOBILE CART SCROLL UP
******************/

//when mobile cart opens, scroll to top so people can see it
function scrollToTop() {
  $('html,body').animate( {
    scrollTop: 0
  }, 400 );
}



/*********************
CART CLOSE LAYER
*********************/

$HTMLCartCloser = $( '.js-cartCloser' );

function cartCloser_show() {
  $HTMLCartCloser.addClass( 'active' );
}


function cartCloser_hide() {
  $HTMLCartCloser.removeClass( 'active' );
}


function cartCloser_bindClick() {
  $HTMLCartCloser.click( function(e) {
    cartMain_close();
  });
}